import CalendarComponent from 'src/components/calendars';
import React, { useEffect, useState } from 'react';
import SimpleCalendar from 'src/components/calendars/SimpleCalendar';
import classNames from 'classnames';
import styles from './assets/case-calendar-screen.module.scss';
import Loader from 'src/components/Loader';
import { ICase } from 'src/types/case';
import { ISeance } from 'src/types/seance';
import { QueryParams } from 'src/types/grid';
import { Paginated } from 'src/services/api-handlers/pagination';
import EventForm from './components/EventForm';
import moment from 'moment';
import LegendComponent from 'src/components/calendars/LegendComponent';
import { IStudent } from 'src/types/student';
import { DropdownList } from 'react-widgets';
import { IProvider } from '../../../../../../../../types/provider';
import history from 'src/navigation/history';
import { useCookies } from 'react-cookie';
import Multiselect from 'multiselect-react-dropdown';

import Select from 'react-select';
import user from '../../../../../../../../services/user-auth';
import UserRole from '../../../../../../../../enumerables/user-role';

export interface StateProps {
    inProgress: boolean;
    inProgressSeances: boolean;
    caseEnt: ICase | null;
    seances: Paginated<ISeance>;
    providers: Paginated<IProvider>;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    getCases: (params: QueryParams) => void;
    updateCaseAction: (data: AnyObject) => void;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export interface OwnProps {
    student: Partial<IStudent> | null;
    subId: string;
    tab?: string;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const Calendar: React.FunctionComponent<Props> = (props: Props) => {
    // const myEventsList: any = [];
    const [date, setDate] = useState<Date | null>(new Date());
    const [calendar, setCalendar] = useState<boolean>(false);
    const [providerState, setProvider] = useState<{ label: string; value: string | number } | undefined>(undefined);
    const [month, setMonth] = useState<{ monthEnd: string; monthStart: string }>({
        monthStart: moment().startOf('month').format(),
        monthEnd: moment().endOf('month').format(),
    });
    const {
        // providerId,
        caseEnt,
        inProgress,
        providers,
        getProviders,
        inProgressSeances,
        getData,
        seances,
        student,
        getCases,
    } = props;

    const [cookies, setCookie] = useCookies(['stCalProviderIDs']);

    useEffect(() => {
        getProviders({
            page: 1,
            itemsPerPage: 1200,
        });

        // eslint-disable-next-line
    }, [getCases]);

    useEffect(() => {
        getCases({
            filters: {
                'student.id': student?.id,
                onlyMy: 1,
                all: 1,
            },
        });
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        let provIds = '';
        cookies.stCalProviderIDs?.forEach((prov: any) => {
            if (prov && prov.value) {
                provIds = provIds + ',' + prov?.value;
            }
        });

        getData({
            page: 1,
            itemsPerPage: 1200,
            filters: {
                'student.id': student?.id,
                showAll: '1',
                providers: provIds,
                'seanceDate[after]': month.monthStart,
                'seanceDate[before]': month.monthEnd,
            },
        });

        // eslint-disable-next-line
    }, [month, cookies.stCalProviderIDs]);

    let start: any = undefined;
    let end: any = undefined;
    if (props?.caseEnt) {
        start = new Date(`${props?.caseEnt?.caseNumberValidityFrom}`).getTime() - 120 * 60 * 1000;
        end = new Date(`${props?.caseEnt?.caseNumberValidityTo}`).getTime();
    } else {
    }
    const onChangeDate = (date: Date | any) => {
        const endOfDat = new Date(`${date}`);

        endOfDat.setHours(12, 59, 59, 999);
        setDate(endOfDat);
    };
    const onChangeNav = (date: Date) => {
        const monthStart = moment(date).startOf('month').format('YYYY-M-D');
        const endOfDat = moment(date).startOf('month').toDate();

        endOfDat.setHours(23, 59, 59, 999);
        const monthEnd = moment(date).endOf('month').format('YYYY-M-D');
        setDate(endOfDat);
        setMonth({
            monthStart,
            monthEnd,
        });
    };

    const providerValues: SelectObject[] = [];
    providers.list.forEach((prov: Partial<IProvider>) => {
        providerValues.push({ value: prov.id, label: `${prov.fullName}` });
    });
    providerValues.sort((a: SelectObject, b: SelectObject) => {
        const textA = a.label.toUpperCase();
        const textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    const onSelect = (selectedList: any, selectedItem: any) => {
        setProvider(selectedItem);
        setCookie('stCalProviderIDs', selectedList, {
            path: '/',
        });
    };

    const onRemove = (selectedList: any, removedItem: any) => {
        setCookie('stCalProviderIDs', selectedList, {
            path: '/',
        });
    };

    const selectedValue = cookies.stCalProviderIDs;

    const style = {
        chips: {
            background: '#3e81b9',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
        },
        searchBox: {
            cursor: 'pointer',
        },
        multiselectContainer: {
            color: '#3e81b9',
            zIndex: '15',
        },
        optionContainer: {
            zIndex: '15',
        },
        option: {
            background: 'white',
            color: '#3e81b9',
        },
    };

    const isSupervisor = user.getSupervisor();
    const isProvider = !user.getRoles().includes(UserRole.ROLE_ADMIN) && !isSupervisor;

    return (
        <div>
            {isProvider ? null : (
                <div className="w-100 mt-3 mb-4 ">
                    <div>Choose Provider:</div>
                    <Multiselect
                        options={[...providerValues]} // Options to display in the dropdown
                        selectedValues={selectedValue} // Preselected value to persist in dropdown
                        onSelect={onSelect} // Function will trigger on select event
                        onRemove={onRemove} // Function will trigger on remove event
                        displayValue="label" // Property name to display in the dropdown options
                        closeIcon="close"
                        placeholder=""
                        style={style}
                        emptyRecordMsg=""
                        hidePlaceholder={true}
                        showArrow={true}
                    />
                </div>
            )}
            <div className={classNames(styles.calendarWrap)}>
                <div className="">
                    {inProgress || inProgressSeances ? <Loader /> : null}
                    <div className={classNames(styles.calendarsTop)}>
                        <LegendComponent />
                        <div className={classNames(styles.calendarMini)}>
                            {calendar ? (
                                <SimpleCalendar
                                    min={start}
                                    setDate={onChangeDate}
                                    containerClassName={classNames(styles.absoluteCalendar)}
                                    max={end}
                                    nowDate={date}
                                    navigateDate={onChangeNav}
                                    open={'date'}
                                />
                            ) : null}
                            <button className={`btn btn-info`} onClick={(e) => setCalendar(!calendar)} type={'button'}>
                                Navigate
                            </button>
                        </div>
                    </div>
                    <div className="w-100">
                        <CalendarComponent
                            caseEnt={caseEnt}
                            seances={seances}
                            change={true}
                            month={month}
                            seanceForm={EventForm}
                            nowDate={date}
                            setEvent={(data) => props.updateCaseAction({ ...data })}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Calendar;
